import React from "react";

import { CssBaseline } from "@mui/material";
import Theme from "config/Theme";
import { PublicDataProvider } from "context/PublicDataContext";
import { UserDataProvider } from "context/UserDataContext";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom";
import "animate.css";
import "react-image-gallery/styles/css/image-gallery.css";

import App from "./App";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/push-service-worker.js")
      .then((registration) => {
        console.debug("Push Service Worker registered:", registration);
      })
      .catch((error) => {
        console.error("Push Service Worker registration failed:", error);
      });
  });
}

ReactDOM.render(
  <React.StrictMode>
    <PublicDataProvider>
      <UserDataProvider>
        <SnackbarProvider maxSnack={3}>
          <Theme>
            <CssBaseline />
            <App />
          </Theme>
        </SnackbarProvider>
      </UserDataProvider>
    </PublicDataProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
